module.exports = __webpack_public_path__ + "img/consultancy-overview-1.b4b658aa.svg";